// ======================================
// CHEFKOCH GLOBALE WISHLIST LOGIK
// ======================================

// 1. Zähler im Header aktualisieren (Desktop & Mobile absolut synchron)
function updateWishlistHeaderCount() {
  const storageKey = 'chefkoch_wishlist';
  let savedIds = [];
  try {
    savedIds = JSON.parse(localStorage.getItem(storageKey) || '[]');
  } catch(e) {}

  const count = savedIds.length;

  // Sucht gezielt ALLE Blasen (Desktop und Mobile-Drawer)
  const bubbles = document.querySelectorAll('[id="wishlist-count-bubble"]');
  const textNodes = document.querySelectorAll('[id="wishlist-count-text"]');

  bubbles.forEach(bubble => {
    // CHEFKOCH FIX: !important zwingt auch das Mobile-CSS von Dawn in die Knie
    if (count > 0) {
      bubble.style.setProperty('display', 'flex', 'important');
    } else {
      bubble.style.setProperty('display', 'none', 'important');
    }
  });

  textNodes.forEach(textNode => {
    textNode.textContent = count;
  });
}

// 2. UI synchronisieren
function syncWishlistUI() {
  const storageKey = 'chefkoch_wishlist';
  let list = JSON.parse(localStorage.getItem(storageKey) || '[]');
  
  // Greift beide möglichen Button-Klassen ab
  document.querySelectorAll('[data-wishlist-toggle], [data-wishlist-button]').forEach(toggle => {
    if (list.includes(toggle.dataset.productId)) {
      toggle.classList.add('is-active');
    } else {
      toggle.classList.remove('is-active');
    }
  });
}

// 3. Zentrale Klick-Steuerung für die gesamte Seite
document.addEventListener('click', function(e) {
  const toggle = e.target.closest('[data-wishlist-toggle], [data-wishlist-button]');
  if (!toggle) return; 

  e.preventDefault();
  const productId = toggle.dataset.productId;
  if (!productId) return;

  const storageKey = 'chefkoch_wishlist';
  let list = JSON.parse(localStorage.getItem(storageKey) || '[]');

  if (list.includes(productId)) {
    list = list.filter(id => id !== productId); 
  } else {
    list.push(productId); 
  }

  list = Array.from(new Set(list));
  localStorage.setItem(storageKey, JSON.stringify(list));

  syncWishlistUI();
  updateWishlistHeaderCount();
});

// 4. Ausführen, wenn die Seite geladen ist
document.addEventListener('DOMContentLoaded', function() {
  updateWishlistHeaderCount();
  syncWishlistUI();
});

// 5. Listener für dynamisch nachgeladene Produkte (z.B. Slider)
document.addEventListener('wishlist:updated', function() {
  syncWishlistUI();
  updateWishlistHeaderCount();
});